module.exports = __webpack_public_path__ + "static/media/audio_recorder.f0d59ad3.jpg";